export default __webpack_public_path__ + "static/media/specialBG.466e8953.jpg";